import siteIds from '../../../constants/siteIds';
import BudgetSourceImage from '../../../assets/headerImages/budgetsource-logo.png';
import BuyersPlusImage from '../../../assets/headerImages/buyersplus-logo.png';
import DefaultImage from '../../../assets/headerImages/DEFAULT_LANDING_IMAGE.png';
import EssentialsForHomeImage from '../../../assets/headerImages/ESSENTIALS_4_HOME_gift_card.png';
import FunSourceImage from '../../../assets/headerImages/FUN_SOURCE_gift_card.png';
import GiftCardConnectImage from '../../../assets/headerImages/GCC_gift_card_logo.png';
import HomePlayImage from '../../../assets/headerImages/HOME_PLAY_gift_card.png';
import PulseImage from '../../../assets/headerImages/PULSE_gift_card.png';
import RizzbatesImage from '../../../assets/headerImages/RIZZBATES_gift_card.png';
import SaversSolutionImage from '../../../assets/headerImages/saverssolution-logo.png';
import SavingsCentralImage from '../../../assets/headerImages/SAVINGS_CENTRAL_gift_card.png';
import TasteForSavingsImage from '../../../assets/headerImages/TASTE_4_SAVINGS_gift_card.png';
import ValueAccessImage from '../../../assets/headerImages/VALUE_ACCESS_gift_card.png';
import ValuePlusImage from '../../../assets/headerImages/VALUE_PLUS_gift_card.png';
import ValueSourceImage from '../../../assets/headerImages/valuesource-logo.png';

export default function (siteId) {
	switch (siteId) {
		case siteIds.giftCardConnection:
			return GiftCardConnectImage;
		case siteIds.valuePlus:
			return ValuePlusImage;
		case siteIds.savingsCentral:
			return SavingsCentralImage;
		case siteIds.tasteForSavings:
			return TasteForSavingsImage;
		case siteIds.homePlay:
			return HomePlayImage;
		case siteIds.valueAccess:
			return ValueAccessImage;
		case siteIds.essentialsForHome:
			return EssentialsForHomeImage;
		case siteIds.rizzbates:
			return RizzbatesImage;
		case siteIds.pulse:
			return PulseImage;
		case siteIds.funSource:
			return FunSourceImage;
		case siteIds.budgetSource:
			return BudgetSourceImage;
		case siteIds.buyersPlus:
			return BuyersPlusImage;
		case siteIds.saversSolution:
			return SaversSolutionImage;
		case siteIds.valueSource:
			return ValueSourceImage;
		default:
			return DefaultImage;
	}
}
